import { useMutation, useApolloClient } from '@apollo/react-hooks';
import { CartIdContext } from '../Cart/CartIdContext';
import { getDecrementQuantityOptimisticResponse } from './cartMutationUtils';
import { useContext } from 'react';
import throwErrorInDev from '../../helpers/throwErrorInDev';
export default function useDecrementQuantity({ decrementQuantityMutation, cartQuery }) {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to useDecrementQuantity`);
    const { cartId } = useContext(CartIdContext);
    const client = useApolloClient();
    const [decrementQuantityMutationFn] = useMutation(decrementQuantityMutation, {
        onCompleted: () => localStorage.setItem('cartChange', '1')
    });
    function decrementQuantity({ itemId }) {
        return decrementQuantityMutationFn({
            variables: {
                input: {
                    cartId,
                    itemId
                }
            },
            optimisticResponse: {
                decrementItemQuantity: {
                    cart: getDecrementQuantityOptimisticResponse({
                        itemId,
                        client,
                        cartId,
                        cartQuery
                    }),
                    __typename: 'CartMutation'
                }
            }
        });
    }
    return { decrementQuantity };
}
//# sourceMappingURL=useDecrementQuantity.js.map